// src/components/Header.jsx
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import logoPNG from './logo.png';

const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #4285f4;
  color: white;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const LogoImage = styled.img`
  width: 50px; /* Ajustez la taille du logo selon vos besoins */
  height: auto;
  margin-right: 10px; /* Espacement entre le logo et le texte */
`;

const LogoText = styled.h1`
  font-size: 1.5rem;
  margin: 0;
`;

const Nav = styled.nav`
  display: flex;
  gap: 1rem;
`;

const NavLink = styled(Link)`
  color: white;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
  
  &.active {
    background-color: rgba(255, 255, 255, 0.3);
  }
`;

const LogoutButton = styled.button`
  background-color: transparent;
  color: white;
  border: 1px solid white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    background-color: white;
    color: #4285f4;
  }
`;

const Header = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    navigate('/');
  };

  return (
    <HeaderContainer>
      <LogoContainer>
        <LogoImage src={logoPNG} alt="NeoBotiQc Logo" />
        <LogoText>NeoBotiQc - NeoBot de Veille</LogoText>
      </LogoContainer>
      <Nav>
        <NavLink to="/dashboard">Tableau de bord</NavLink>
        <NavLink to="/email-stats">Statistiques</NavLink>
        <NavLink to="/new-veille">Nouvelle veille</NavLink>
        <LogoutButton onClick={handleLogout}>Déconnexion</LogoutButton>
      </Nav>
    </HeaderContainer>
  );
};

export default Header;